// This file is used for maintain and manage API services.
;(function () {
  'use strict'
  angular.module('obex').factory('tripsDashBoard', [
    '$http',
    '$q',
    'obexConstant',
    'authService',
    ($http, $q, obexConstant, authService) => {
      return {
        getTripsDash(fromDate, toDate, orgId) {
          return authService.getAuthorizationHeader().then((authHeader) => {
            const url = `${obexConstant.urlTrips}/admin/${fromDate}/${toDate}/${orgId}`
            return $http.get(url, {
              headers: authHeader,
            })
          })
        },
        getFlightsDash(fromDate, toDate, orgId) {
          return authService.getAuthorizationHeader().then((authHeader) => {
            const url = `${obexConstant.urlFlights}/admin/${fromDate}/${toDate}/${orgId}`
            return $http.get(url, {
              headers: authHeader,
            })
          })
        },
        getHotelsDash(fromDate, toDate, orgId) {
          return authService.getAuthorizationHeader().then((authHeader) => {
            const url = `${obexConstant.urlHotels}/admin/${fromDate}/${toDate}/${orgId}`
            return $http.get(url, {
              headers: authHeader,
            })
          })
        },
        getCarsDash(fromDate, toDate, orgId) {
          return authService.getAuthorizationHeader().then((authHeader) => {
            const url = `${obexConstant.urlCars}/admin/${fromDate}/${toDate}/${orgId}`
            return $http.get(url, {
              headers: authHeader,
            })
          })
        },
        getLimosDash(fromDate, toDate, orgId) {
          return authService.getAuthorizationHeader().then((authHeader) => {
            const url = `${obexConstant.urlLimos}/admin/${fromDate}/${toDate}/${orgId}`
            return $http.get(url, {
              headers: authHeader,
            })
          })
        },
        getTripsDashbyId(tripId) {
          return authService.getAuthorizationHeader().then((authHeader) => {
            const url = `${obexConstant.urlTrips}/admin/${tripId}`
            return $http.get(url, {
              headers: authHeader,
            })
          })
        },
        getFlightsDashById(flightId) {
          return authService.getAuthorizationHeader().then((authHeader) => {
            const url = `${obexConstant.urlFlights}/admin/${flightId}`
            return $http.get(url, {
              headers: authHeader,
            })
          })
        },
        getHotelsDashById(hotelId) {
          return authService.getAuthorizationHeader().then((authHeader) => {
            const url = `${obexConstant.urlHotels}/admin/${hotelId}`
            return $http.get(url, {
              headers: authHeader,
            })
          })
        },
        getCarsDashById(carId) {
          return authService.getAuthorizationHeader().then((authHeader) => {
            const url = `${obexConstant.urlCars}/admin/${carId}`
            return $http.get(url, {
              headers: authHeader,
            })
          })
        },
        getLimosDashById(limoId) {
          return authService.getAuthorizationHeader().then((authHeader) => {
            const url = `${obexConstant.urlLimos}/admin/${limoId}`
            return $http.get(url, {
              headers: authHeader,
            })
          })
        },
        updateFlightStatus(flightId, flight) {
          return authService.getAuthorizationHeader().then((authHeader) => {
            const url = `${obexConstant.urlFlights}/agent/${flightId}`
            const putData = {
              Id: flight.Id,
              NewAgentNote: flight.NewAgentNote,
            }
            return $http.put(url, putData, {
              headers: authHeader,
            })
          })
        },
        updateCarStatus(carId, car) {
          return authService.getAuthorizationHeader().then((authHeader) => {
            const url = `${obexConstant.urlCars}/agent/${carId}`
            const putData = {
              Id: car.Id,
              NewAgentNote: car.NewAgentNote,
            }
            return $http.put(url, putData, {
              headers: authHeader,
            })
          })
        },
        updateHotelStatus(hotelId, hotel) {
          return authService.getAuthorizationHeader().then((authHeader) => {
            const url = `${obexConstant.urlHotels}/agent/${hotelId}`
            const putData = {
              Id: hotel.Id,
              NewAgentNote: hotel.NewAgentNote,
            }
            return $http.put(url, putData, {
              headers: authHeader,
            })
          })
        },
        updateLimoStatus(limoId, limo) {
          return authService.getAuthorizationHeader().then((authHeader) => {
            const url = `${obexConstant.urlLimos}/agent/${limoId}`
            const putData = {
              Id: limo.Id,
              NewAgentNote: limo.NewAgentNote,
            }
            return $http.put(url, putData, {
              headers: authHeader,
            })
          })
        },
        getVirtualCardImage(deploymentId, organizationId) {
          return authService.getAuthorizationHeader().then((authHeader) => {
            const url = `${obexConstant.urlVirtualCardImage}/${deploymentId}/organizationid/${organizationId}`
            return $http.get(url, {
              headers: authHeader,
            })
          })
        },
      }
    },
  ])
})()



// WEBPACK FOOTER //
// ./client/js/services/tripsDashBoard.service.js